import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { style } from '@vanilla-extract/css';

export const overlay = style(
  {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: themeVars.color['surface-base'],
    transition: 'opacity 75ms',
    pointerEvents: 'none',
  },
  'dropzone-overlay',
);

export const overlayActive = style({ opacity: 0.9, pointerEvents: 'auto' }, 'dropzone-overlay-active');

export const overlayInactive = style({ opacity: 0, pointerEvents: 'none' }, 'dropzone-overlay-inactive');
